module.exports = __webpack_public_path__ + "img/9788991799820.e1e94373.jpg";